import {Grid, IconButton, Input, useTheme, withStyles} from "@material-ui/core";
import {Field} from "formik";
import classNames from "classnames";
import style, {useFormStyles} from "./styles";
import React, {useLayoutEffect, useRef, useState} from "react";
import Select from "react-select-material-ui"
import {IconExpandir as ArrowDropDown} from '../icons/MateraIcons';

const InputSelectBuilder = (props) => {
    const classes = useFormStyles();
    const theme = useTheme()
    const [options, setOptions] = useState([]);
    const refSelect = useRef()
    useLayoutEffect(() => {
        if (schema.options instanceof Promise)
            schema.options.then(data => setOptions(data))
        else
            setOptions(schema.options)
    }, []);
    const {fieldSchema: schema} = props;
    const CustomOption = () => <IconButton tabIndex={-1} size={'small'}>
        <ArrowDropDown/>
    </IconButton>

    const selectStyles = {
        dropdownIndicator: (base) => ({
            ...base,
            color: theme.palette.text.primary,
            padding: 5,
            borderRadius: 4,
            marginBottom: 10,
            '&:hover': {
                color: theme.palette.text.primary,
                background: theme.palette.background.paper
            },
            marginRight: 0,

        }),
        clearIndicator: (base) => ({
            ...base,
            color: theme.palette.text.primary
        }),
        singleValue: (base) => ({
            ...base,
            color: theme.palette.text.primary,
            borderRadius: 3,
        }),
        option: (base) => ({
            ...base,
            color: "primary",
            background: theme.palette.background.paper,
            '&:hover': {
                background: theme.palette.background.default
            }
        }),
        control: (base, state) => ({
            ...base,
            color: "primary",
            background: "transparent",
            borderBottomWidth: 0,
            borderLeftWidth: 0,
            borderRightWidth: 0,
            borderTopWidth: 0,
            borderRadius: 0,
            boxShadow: "none",
            marginRight: 0,
            boxSizing: 'border-box'
        }),
        indicatorsContainer: (base) => ({
            ...base,
            margin: 0,
            marginBottom: 5,
        }),
        indicatorContainer: (base) => ({
            ...base,
            margin: 0,
            marginBottom: 5,
        }),
        indicatorSeparator: () => ({})
    };
    return <Grid item {...schema.sizes}>
        <Field name={schema.field} {...props}>{
            ({field, form}) =>
                <Select
                    {...field}
                    ref={refSelect}
                    color="primary"
                    InputLabelProps={{
                        className: classNames(classes.label, 'MuiFormLabel-filled'),
                        htmlFor: schema.label + '-field',
                        style: {
                            color: 'currentColor'
                        },
                        color: 'secondary',
                        required: schema.required,
                    }}
                    SelectProps={{
                        components: {
                            DropdownIndicator: CustomOption
                        },
                        styles: selectStyles
                    }}
                    id={schema.label + '-field'}
                    label={schema.label}
                    className={classNames(classes.margin, classes.textField, 'MuiInput-underline')}
                    value={(options?.length > 0 && ((field.value?.length && field.value) || schema.default)) || ''}
                    input={<Input/>}
                    disabled={schema.disabled}
                    options={options?.map(o => ({label: o.descricao, value: o.codigo})) ?? []}
                    fullWidth
                    placeholder={schema.placeholder ?? schema.label}
                    onChange={(value) => form.setFieldValue(schema.field, value)}
                />
        }
        </Field>
    </Grid>;
};

export default withStyles(style)(InputSelectBuilder);
